import { NavLink } from 'react-router-dom';

export function LibraryNav() {
  return <nav className="library-subnav" aria-label="Library views">
    <NavLink end to="/library">Market</NavLink>
    <NavLink to="/library/captures">Captures</NavLink>
  </nav>;
}
